import React, { FC } from "react";

import "../styles.scss";
import "../scripts";

import {
  KameleonElement,
  primaryCollectionBlock,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { webflowHOC } from "@kameleon-common/webflow-js";
import { Variants } from "@kameleon-util/global-theme";
import {
  blockConfig,
  ContentCollectionItem,
  ContentCollectionItemType,
} from "./components/content-collection-item";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import {
  ContentCollectionType as ComponentType,
  layoutOptions,
} from "./types/prop-types";
import getEvents from "./js/webflow";

type ContentCollectionType = {
  PrimaryBlocks: ContentCollectionItemType[];
} & ComponentType;

const Component: FC<ContentCollectionType> = ({
  PrimaryBlocks,
  tagline,
  header,
  description,
  layoutProps,
}: ContentCollectionType) => (
  <Box className="primary-collection-content-collection-accordion-dropdowns-v1">
    <Box className="padding-global">
      <Box className="container-large">
        <Box className="padding-section-large">
          <Box
            className={`${
              layoutProps.columnCount === 1
                ? "layout-grid-single"
                : "w-layout-grid"
            } career21_component`}
          >
            <Box className="career21_content">
              <Box className="margin-bottom margin-xsmall">
                <Variants.TagLine>{tagline}</Variants.TagLine>
              </Box>
              <Box className="margin-bottom margin-small">
                <Variants.Heading>{header}</Variants.Heading>
              </Box>
              <Variants.ParagraphDefault>
                {description}
              </Variants.ParagraphDefault>
            </Box>
            <Box className="career2_component vertical-gap">
              {PrimaryBlocks?.map((primaryBlockProps, index) => (
                <ContentCollectionItem key={index} {...primaryBlockProps} />
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>
);
const ComponentWithWebflow = webflowHOC(Component, [
  {
    module: "ix2",
    getEvents: (pageId): object => getEvents(pageId),
  },
]);

export const ContentCollection = primaryCollectionBlock<ContentCollectionType>(
  blockConfig,
  ({ PrimaryBlocks, ...props }: ContentCollectionType) => (
    <ComponentWithWebflow PrimaryBlocks={PrimaryBlocks} {...props} />
  )
);

ContentCollection.defaultProps =
  getDefaultProps<ContentCollectionType>(defaults);

export const Element: KameleonElement = {
  component: ContentCollection,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
